import React, { useState } from 'react';

export function Tab({ children }) {
  return <div className="p-4 bg-gray-900 rounded-b-lg text-white overflow-x-auto">{children}</div>;
}

export function Tabs({ items = [], children }) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  let itemList = items;
  if (typeof items === 'string') {
    itemList = items.split('|').filter(Boolean);
  }

  const childrenArray = React.Children.toArray(children).filter((child) => {
    if (typeof child === 'string') {
      return child.trim().length > 0;
    }
    return true;
  });

  return (
    <div className="my-4 border border-gray-700 rounded-lg overflow-hidden bg-gray-900 shadow-md">
      {itemList && itemList.length > 0 && (
        <div className="flex flex-wrap border-b border-gray-700 bg-gray-800/80 px-2 pt-2 gap-1 overflow-x-auto">
          {itemList.map((item, index) => (
            <button
              key={index}
              type="button"
              onClick={() => setSelectedIndex(index)}
              className={`px-3 py-1.5 text-xs font-medium rounded-t-md transition-colors ${
                selectedIndex === index
                  ? 'bg-gray-900 text-cyan-400 border-t-2 border-cyan-400 font-semibold'
                  : 'text-gray-400 hover:text-gray-200 hover:bg-gray-700/50'
              }`}
            >
              {item}
            </button>
          ))}
        </div>
      )}
      <div className="p-0">
        {childrenArray[selectedIndex] || childrenArray[0] || children}
      </div>
    </div>
  );
}

Tabs.Tab = Tab;

export default Tabs;
